var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useRef } from "react";
import { useListContext } from "react-admin";
export var PreloadedList = function (_a) {
    var defaultFilters = _a.defaultFilters, children = _a.children, resource = _a.resource, props = __rest(_a, ["defaultFilters", "children", "resource"]);
    var _b = useListContext(), setFilters = _b.setFilters, filterValues = _b.filterValues;
    var hasSetInitialFilters = useRef(false);
    useEffect(function () {
        // Only set filters once when defaultFilters are available and not yet set
        if (defaultFilters &&
            !hasSetInitialFilters.current &&
            Object.keys(defaultFilters).length > 0) {
            setFilters(defaultFilters, {});
            hasSetInitialFilters.current = true;
        }
    }, [defaultFilters, setFilters]);
    // Prevent filter reset on re-renders
    useEffect(function () {
        return function () {
            hasSetInitialFilters.current = false;
        };
    }, []);
    return _jsx(_Fragment, { children: children });
};
